import React from 'react';
import factory from 'components/Icons/factory';

export const Close = factory(
  'Close',
  <g>
    <path d="M72.8 64l53.4-53.4a6.2 6.2 0 0 0 0-8.8 6.2 6.2 0 0 0-9 0L64 55 10.6 1.8a6.2 6.2 0 0 0-8.8 0 6.2 6.2 0 0 0 0 9L55 64 1.8 117.4a6.2 6.2 0 0 0 0 8.8 6.2 6.2 0 0 0 9 0L64 73l53.4 53.4a6.2 6.2 0 0 0 8.8-8.8z" />
  </g>
);

export default Close;
